// Copyright (c) 2026 Theiagen Genomics. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use is prohibited.
// Pure (de)serialisation of a viewer session into a JSON-safe object.
// No DOM, no window — this is the portable on-disk shape of a tree view.
import { defaultProps } from "./defaults.js";

export const SESSION_VERSION = 1;

// Keep only props the viewer actually understands (those with a default)
// and that survive JSON: drop unknown keys and any function values
// (e.g. a user-supplied branchLengthsFormat formatter or event callbacks).
export function pickSessionProps(props, defaults) {
  const out = {};
  for (const key of Object.keys(defaults)) {
    if (!(key in props)) continue;
    const value = props[key];
    if (typeof value === "function") continue;
    out[key] = value;
  }
  return out;
}

export function buildSession({ source, props, view, highlightedId }) {
  return {
    version: SESSION_VERSION,
    source,
    props: pickSessionProps(props, defaultProps),
    view: view ? { ...view } : null,
    highlightedId: highlightedId ?? null,
  };
}
